<template>
    <div class="play-box" :style="{ right: show ? '20px' : '-164px' }">
        <div class="card">
            <div class="arr-tool" style="width: 30px;" @click="show = !show">
                <i class="el-icon-d-arrow-left text-white font-lgx" v-if="!show"></i>
                <i class="el-icon-d-arrow-right text-white font-lgx" v-else></i>
            </div>
            <div class="top">
                <div class="pfp">
                    <div class="playing" v-if="playing" @click="pause">
                        <div class="greenline line-1"></div>
                        <div class="greenline line-2"></div>
                        <div class="greenline line-3"></div>
                        <div class="greenline line-4"></div>
                        <div class="greenline line-5"></div>
                    </div>
                    <i class="el-icon-video-play loading" @click="play" v-else></i>
                </div>
                <div class="texts">
                    <p class="title-1">绿色的旋律</p>
                    <p class="title-2">陈洁丽</p>
                </div>
            </div>
        </div>
        <audio ref="audio" :src="audioSrc" :autoplay="false" loop />
    </div>
</template>
<script>
	export default {
        data() {
            return {
                show: false,
                playing: false,
                audioSrc: 'https://no924worker.oss-cn-heyuan.aliyuncs.com/common/%E9%99%88%E6%B4%81%E4%B8%BD%20-%20%E7%BB%BF%E8%89%B2%E7%9A%84%E6%97%8B%E5%BE%8B.mp3'
            }
        },
        methods: {
            play(){
                this.$refs.audio.play().then(() => {
                    this.playing = true
                }).catch(err => {
                    console.log("播放失败：", err); // 可能是浏览器仍不允许，或资源问题
                });
            },
            pause(){
                this.$refs.audio.pause()
                this.playing = false
            }
        }
    }
</script>
<style scoped lang="scss">
.play-box{
    position: fixed;
    right: -164px;
    bottom: 10px;
    z-index: 9249;
    transition: 300ms;
}
.card {
    position: relative;
    width: 210px;
    height: 50px;
    background: #544d4d;
    border-radius: 10px;
    padding: 5px;
    cursor: pointer;
}
.arr-tool{
    position: absolute;
    left: 30px;
    top: 18px;
    transition: 300ms;
}
.card:hover .arr-tool{
    left: -30px;
}

.top {
    position: relative;
    width: 100%;
    display: flex;
    gap: 10px;
}

.pfp {
    position: relative;
    top: 5px;
    left: 5px;
    height: 40px;
    width: 40px;
    background-color: #d2d2d2;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.loading{
    transition: 300ms;
    font-size: 22px;
}
.pfp:hover .loading{
    transform: scale(1.2);
}

.texts{
    padding-top: 3px;
    padding-left: 8px;
}

.title-1 {
    color: white;
    font-size: 18px;
    font-weight: bolder;
}

.title-2 {
    color: white;
    font-size: 12px;
    font-weight: bold;
}

.playing {
    display: flex;
    position: relative;
    justify-content: center;
    gap: 1px;
    width: 30px;
    height: 20px;
}

.greenline {
    background-color: #1db954;
    height: 20px;
    width: 2px;
    position: relative;
    transform-origin: bottom;
}

.line-1 {
    animation: infinite playing 1s ease-in-out;
    animation-delay: 0.2s;
}

.line-2 {
    animation: infinite playing 1s ease-in-out;
    animation-delay: 0.5s;
}

.line-3 {
    animation: infinite playing 1s ease-in-out;
    animation-delay: 0.6s;
}

.line-4 {
    animation: infinite playing 1s ease-in-out;
    animation-delay: 0s;
}

.line-5 {
    animation: infinite playing 1s ease-in-out;
    animation-delay: 0.4s;
}

@keyframes playing {
    0% {
        transform: scaleY(0.1);
    }

    33% {
        transform: scaleY(0.6);
    }

    66% {
        transform: scaleY(0.9);
    }

    100% {
        transform: scaleY(0.1);
    }
}
</style>